export const MAX_ASSIGNED_DEFINITION_TASK_LIMIT_REACHED =
  'MAX_ASSIGNED_DEFINITION_TASK_LIMIT_REACHED'
